import type { ReactNode } from "react";
import { cn } from "@wa/ui";

/** ok = settled, wt = waiting on somebody, lt = late or refused, info, mut. */
export type StatusTone = "ok" | "wt" | "lt" | "info" | "mut";

const TONE: Record<StatusTone, string> = {
  ok: "crm-st-ok",
  wt: "crm-st-wt",
  lt: "crm-st-lt",
  info: "crm-st-info",
  mut: "crm-st-mut",
};

/**
 * The status pill. Colour plus a dot, never colour alone: the five tones are
 * distinguishable by shade but the dot is what survives a bad monitor and
 * colour blindness both.
 *
 * `icon` is the one case that drops the dot. A pill whose whole content is a
 * glyph - the mark a callout leads with - already says its severity without
 * colour, so the dot adds nothing and reads as a stray speck parked next to a
 * warning triangle. It also switches the pill to a square mark, because the
 * pill's gutter is asymmetric to make room for a dot that is no longer there.
 */
export function StatusPill({
  tone,
  icon,
  children,
  className,
}: {
  tone: StatusTone;
  icon?: boolean;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={cn("crm-st", TONE[tone], icon && "crm-st-mark", className)}>
      {icon ? null : <i />}
      {children}
    </span>
  );
}
